import { ProjectCategoryViewComponent } from './../../components/project-category-view/project-category-view.component';
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  ComponentFactoryResolver,
  ComponentRef,
  SimpleChanges,
} from '@angular/core';
import {
  CountryDto,
  StateDto,
  LgaDto,
  ProjectTypeDto,
  ProjectCategoryDto,
  ClusterDto,
  ClusterCommunityDto,
  OilFieldDto,
  OilBlockDto,
  CommunityDto,
  DocumentCategoryDto,
  DocumentSubCategoryDto,
  CurrencyDto,
} from '@cradua/data';
import { ProjectReferenceFormDirective } from '../../directives/project-reference-form.directive';
import { CountryViewComponent } from '../../components/country-view/country-view.component';
import { StateViewComponent } from '../../components/state-view/state-view.component';
import { LgaViewComponent } from '../../components/lga-view/lga-view.component';
import { CurrencyViewComponent } from '../../components/currency-view/currency-view.component';
import { CommunityViewComponent } from '../../components/community-view/community-view.component';
import { ProjectTypeViewComponent } from '../../components/project-type-view/project-type-view.component';
import { ClusterViewComponent } from '../../components/cluster-view/cluster-view.component';
import { ClusterCommunityViewComponent } from '../../components/cluster-community-view/cluster-community-view.component';
import { OilBlockViewComponent } from '../../components/oil-block-view/oil-block-view.component';
import { OilFieldViewComponent } from '../../components/oil-field-view/oil-field-view.component';
import { DocumentCategoryViewComponent } from '../../components/document-category-view/document-category-view.component';
import { DocumentSubCategoryViewComponent } from '../../components/document-sub-category-view/document-sub-category-view.component';
import { ProjectReferenceView } from '../../models/project-reference.interface';

const componentMapper = {
  country: CountryViewComponent,
  state: StateViewComponent,
  lga: LgaViewComponent,
  projectCategory: ProjectCategoryViewComponent,
  projectType: ProjectTypeViewComponent,
  cluster: ClusterViewComponent,
  clusterCommunity: ClusterCommunityViewComponent,
  oilBlock: OilBlockViewComponent,
  oilField: OilFieldViewComponent,
  community: CommunityViewComponent,
  documentCategory: DocumentCategoryViewComponent,
  documentSubCategory: DocumentSubCategoryViewComponent,
  currency: CurrencyViewComponent,
};

@Component({
  selector: 'mrsoftapps-project-reference-form-view',
  templateUrl: './project-reference-form-view.component.html',
  styleUrls: ['./project-reference-form-view.component.css'],
})
export class ProjectReferenceFormViewComponent implements OnInit {
  @ViewChild(ProjectReferenceFormDirective, { static: true })
  placeholder: ProjectReferenceFormDirective;

  @Input() data: any;
  inputData: ProjectReferenceView;
  @Input() countries: CountryDto[];
  @Input() states:  StateDto[];
  @Input() lgas:  LgaDto[];
  @Input() projectTypes: ProjectTypeDto[];
  @Input() projectCategories: ProjectCategoryDto[];
  @Input() clusters: ClusterDto[];
  @Input() clusterCommunities: ClusterCommunityDto[];
  @Input() oilBlocks: OilBlockDto[];
  @Input() oilFields: OilFieldDto[];
  @Input() communities: CommunityDto[];
  @Input() documentCategories: DocumentCategoryDto[];
  @Input() documentSubCategories: DocumentSubCategoryDto[];
  @Input() currencies: CurrencyDto[];

  @Output() changeEmit: EventEmitter<string> = new EventEmitter<string>();
  @Output() deleteEvent: EventEmitter<string> = new EventEmitter<string>();

  componentRef: ComponentRef<any>;
  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    /**
     * We are using this hook for change detection and invoking loadComponent() method
     * There are more ways to do this but for the simplicity of this example I have decided on this way
     */
    if (changes.data) {
      if (changes.data.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.states) {
      if (changes.states.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.lgas) {
      if (changes.lgas.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.projectTypes) {
      if (changes.projectTypes.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.projectCategories) {
      if (changes.projectCategories.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.clusters) {
      if (changes.clusters.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.clusterCommunities) {
      if (changes.clusterCommunities.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.communities) {
      if (changes.communities.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.oilBlocks) {
      if (changes.oilBlocks.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.oilFields) {
      if (changes.oilFields.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.documentCategories) {
      if (changes.documentCategories != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.documentSubCategories) {
      if (changes.documentSubCategories.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.currencies) {
      if (changes.currencies.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    }
  }

  /**
   * A method that loads and creates instances of components
   */
  loadComponent() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }

    /** Preparing our component for creation */
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
      componentMapper[this.data]
    );
    /** Grabbing reference of our view placeholder */
    const viewContainerRef = this.placeholder.viewContainerRef;
    /** Clearing our placeholder  */
    viewContainerRef.clear();
    /** Magic of creating a component instance  */
    this.componentRef = viewContainerRef.createComponent(componentFactory);
    /**
     * @Input data into our instance.
     */

    // (this.componentRef.instance as StudentListView).student = this.inputData.student;
    if (this.data === 'country') {
      (this.componentRef
        .instance as ProjectReferenceView).countries = this.countries;
    } else if (this.data === 'state') {
      (this.componentRef
        .instance as ProjectReferenceView).countries = this.countries;
      (this.componentRef.instance as ProjectReferenceView).states = this.states;
    } else if (this.data === 'lga') {
      (this.componentRef.instance as ProjectReferenceView).states = this.states;
      (this.componentRef.instance as ProjectReferenceView).lgas = this.lgas;
    } else if (this.data === 'cluster') {
      (this.componentRef
        .instance as ProjectReferenceView).projectCategories = this.projectCategories;
      (this.componentRef
        .instance as ProjectReferenceView).clusters = this.clusters;
    } else if (this.data === 'clusterCommunity') {
      (this.componentRef
        .instance as ProjectReferenceView).clusterCommunities = this.clusterCommunities;
      (this.componentRef
        .instance as ProjectReferenceView).clusters = this.clusters;
      (this.componentRef.instance as ProjectReferenceView).states = this.states;
      (this.componentRef.instance as ProjectReferenceView).lgas = this.lgas;
      (this.componentRef
        .instance as ProjectReferenceView).projectCategories = this.projectCategories;
      (this.componentRef
        .instance as ProjectReferenceView).communities = this.communities;
    } else if (this.data === 'projectCategory') {
      (this.componentRef
        .instance as ProjectReferenceView).projectCategories = this.projectCategories;
    } else if (this.data === 'community') {
      (this.componentRef
        .instance as ProjectReferenceView).communities = this.communities;
      (this.componentRef.instance as ProjectReferenceView).lgas = this.lgas;
    } else if (this.data === 'projectType') {
      (this.componentRef
        .instance as ProjectReferenceView).projectCategories = this.projectCategories;
      (this.componentRef
        .instance as ProjectReferenceView).projectTypes = this.projectTypes;
    } else if (this.data === 'oilBlock') {
      (this.componentRef
        .instance as ProjectReferenceView).oilBlocks = this.oilBlocks;
    } else if (this.data === 'oilField') {
      (this.componentRef
        .instance as ProjectReferenceView).oilBlocks = this.oilBlocks;
      (this.componentRef
        .instance as ProjectReferenceView).oilFields = this.oilFields;
    } else if (this.data === 'documentCategory') {
      (this.componentRef
        .instance as ProjectReferenceView).documentCategories = this.documentCategories;
    } else if (this.data === 'documentSubCategory') {
      (this.componentRef
        .instance as ProjectReferenceView).documentCategories = this.documentCategories;
      (this.componentRef
        .instance as ProjectReferenceView).documentSubCategories = this.documentSubCategories;
    } else if (this.data === 'currency') {
      (this.componentRef
        .instance as ProjectReferenceView).currencies = this.currencies;
    }

    /** @Output data from our instance  */
    this.componentRef.instance.changeEmit.subscribe((data) =>
      this.changeEmit.emit(data)
    );

    this.componentRef.instance.deleteEvent.subscribe((data) =>
      this.deleteEvent.emit(data)
    );
  }
}
